/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

/** 与设计稿一致：多行时右侧细滚动条、内边距；需固定高度时在外层设 style / class */
type CommonProps = {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  className?: string;
  inputClassName?: string;
  type?: string;
  style?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
};

/** 单行：供 NumberInput 等按 HTML input 做类型约束（避免对 forwardRef(Input) 用 ComponentProps 时联合类型缺字段） */
export type SingleLineInputProps = CommonProps & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> & {
  multiline?: false;
};

type MultiLineProps = CommonProps & React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  multiline: true;
  type?: string;
};

export type BaseInputProps = SingleLineInputProps | MultiLineProps;

// 多行时渲染 textarea，在固定高度容器内由 overflow-y 与细滚动条表现（见 Figma 31302:47569）
function Input(
  {
    className,
    style,
    leftIcon,
    rightIcon,
    type = 'text',
    inputStyle,
    inputClassName,
    multiline,
    ...rest
  }: BaseInputProps,
  ref: React.Ref<HTMLInputElement | HTMLTextAreaElement>,
) {
  const disabled = 'disabled' in rest ? rest.disabled : false;

  if (multiline) {
    const taProps = rest as React.TextareaHTMLAttributes<HTMLTextAreaElement>;
    const { rows: rowsProp, ...taRest } = taProps;
    return (
      <div
        className={classNames(
          styles.input_container,
          styles.multiline,
          className,
          { [styles.disabled]: disabled },
        )}
        style={style}
      >
        {leftIcon}
        <textarea
          ref={ref as React.Ref<HTMLTextAreaElement>}
          className={inputClassName}
          style={inputStyle}
          rows={rowsProp ?? 3}
          {...taRest}
        />
        {rightIcon}
      </div>
    );
  }

  return (
    <div
      className={classNames(styles.input_container, className, { [styles.disabled]: disabled })}
      style={style}
    >
      {leftIcon}
      <input
        type={type}
        ref={ref as React.Ref<HTMLInputElement>}
        style={inputStyle}
        className={inputClassName}
        {...(rest as React.InputHTMLAttributes<HTMLInputElement>)}
      />
      {rightIcon}
    </div>
  );
}

export default React.forwardRef(Input);
